export default __webpack_public_path__ + "static/media/enterprise.be9c5cd4.png";